module.exports = __webpack_public_path__ + "img/chest-endomorph-male.945026eb.svg";